import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";

function CTAButton({ action, className, showArrow = true }) {
  const content = (
    <>
      {action.label} {showArrow && <ArrowUpRight size={15} />}
    </>
  );
  if (action.to?.startsWith("http")) {
    return (
      <a
        href={action.to}
        target={action.sameTab ? undefined : "_blank"}
        rel={action.sameTab ? undefined : "noopener noreferrer"}
        data-testid={action.testid}
        className={className}
      >
        {content}
      </a>
    );
  }
  return (
    <Link to={action.to} state={action.state} data-testid={action.testid} className={className}>
      {content}
    </Link>
  );
}

export default function CTA({ overline, title, sub, primary, secondary }) {
  return (
    <section className="px-6 py-20 sm:px-10 sm:py-28 lg:px-16">
      <Reveal>
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#0B2B22] px-8 py-16 sm:px-14 sm:py-20">
          <div className="grain absolute inset-0" />
          <div className="absolute -right-24 -top-24 size-72 rounded-full bg-[#2D6A4F]/40 blur-3xl" />
          <div className="absolute -bottom-24 -left-16 size-64 rounded-full bg-[#E05A47]/25 blur-3xl" />
          <div className="relative z-10 max-w-2xl">
            {overline && (
              <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#7FB998]">
                {overline}
              </p>
            )}
            <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-[#F4F7F4]">
              {title}
            </h2>
            {sub && <p className="mt-4 text-base sm:text-lg text-[#F4F7F4]/70">{sub}</p>}
            <div className="mt-8 flex flex-wrap gap-3">
              {primary && (
                <CTAButton
                  action={primary}
                  className="inline-flex items-center gap-2 rounded-full bg-[#E05A47] px-6 py-3 text-sm font-bold text-white shadow-lg transition-colors duration-300 hover:bg-[#c94a39]"
                />
              )}
              {secondary && (
                <CTAButton
                  action={secondary}
                  showArrow={false}
                  className="inline-flex items-center gap-2 rounded-full border border-[#F4F7F4]/35 px-6 py-3 text-sm font-bold text-[#F4F7F4] backdrop-blur transition-colors duration-300 hover:bg-[#F4F7F4]/10"
                />
              )}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
